import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillDeleted.meta';

export type UseTrackSkillDeletedParams = {
  skill_id: string;
  scope: 'private' | 'workspace' | 'builtIn';
};

export const useTrackSkillDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillDeleted = useCallback(
    (params: UseTrackSkillDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillDeleted };
};
